import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";

import { FormattedMessage } from "react-intl";

function AboutThree() {
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <div className="aboutThree">
      <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
        <div className="aboutThreeTitle">
          <div>
            <h1 className={`${isVisible ? "visible" : ""}`}>
              <FormattedMessage
                id="politicTitle"
                defaultMessage="Política Ambiental"
              />
            </h1>
            <p className="politicIntro">
              <FormattedMessage
                id="politicIntro"
                defaultMessage="A Palangana Serviços Marítimos Ltda. tem como principal objetivo garantir um serviço de elevada qualidade aos seus clientes, bem como a satisfação dos seus funcionários e sociedade. Sabendo da importância da sua localização e relação com o mar, integra à sua estratégia de desenvolvimento a preocupação com a preservação ambiental, além de proteger a baía. Para tanto, definiu sua Política Ambiental com os seguintes compromissos:"
              />
            </p>
            <ol className="politicList">
              <li>
                <FormattedMessage
                  id="politicItem1"
                  defaultMessage="Cumprir a Legislação ambiental e os trabalhos assumidos em conformidade legal;"
                />
              </li>
              <li>
                <FormattedMessage
                  id="politicItem2"
                  defaultMessage="Prevenir formas de poluição e reduzir os impactos ambientais significativos associados às suas atividades;"
                />
              </li>
              <li>
                <FormattedMessage
                  id="politicItem3"
                  defaultMessage="Estabelecer e rever periodicamente os objetivos e procedimentos ambientais, promovendo a melhoria contínua do seu desempenho ambiental, visando a redução dos resíduos e a otimização do uso de recursos naturais;"
                />
              </li>
              <li>
                <FormattedMessage
                  id="politicItem4"
                  defaultMessage="Promover a implantação de programas de gerenciamento ambiental e ações práticas de controle ambiental."
                />
              </li>
            </ol>
          </div>
        </div>
      </VisibilitySensor>
    </div>
  );
}

export default AboutThree;
